import React from 'react';

import useOverElement from 'hooks/useOverElement';

import * as S from './ValuesSection.styles';

export interface ValuesSectionProps {
  sectionTitle: string;
  valueCard: Array<{
    title: string;
    rteSubtitle: string;
  }>;
}

const defaultProps: Partial<ValuesSectionProps> = {};

const ValuesSection: React.FunctionComponent<ValuesSectionProps> = ({
  sectionTitle,
  valueCard,
}) => {
  const [ref] = useOverElement();
  const [ref1] = useOverElement();

  return (
    <>
      <S.Title ref={ref}>{sectionTitle}</S.Title>
      <S.Values ref={ref1}>
        {valueCard.map(value => (
          <S.ValueCard key={value.title}>
            <S.ValueTitle>{value.title}</S.ValueTitle>
            <S.ValueContent>{value.rteSubtitle}</S.ValueContent>
          </S.ValueCard>
        ))}
      </S.Values>
    </>
  );
};

ValuesSection.defaultProps = defaultProps;

export default ValuesSection;
